var largeRecipes = [
    {
        spice: '<strong>Curcuma</strong> - Este un condiment de origine asiatică, cu o aromă picantă și amăruie. Parfumul său amintește de cel al ghimbirului cu care, de altfel, se și înrudește. Chef D’Artagnan recomandă acest condiment cu preparate precum wraps sau salate cu carne ușoară. În plus, îl poți adăuga omletelor, pastelor sau orezului, pentru aromă și culoare.',
        name: 'Wrap copt in cuptor<br>cu bacon si salată<br>de primăvară',
        image: 'large-curcuma-recipe.jpg'
    },
    {
        spice: '<strong>Coriandru</strong> - Coriandrul are un miros dulceag și aromat, i se mai spune „pătrunjelul chinezesc”. Semințele sale uscate au o puternică aromă de lămâie și nucă, iar Chef D’Artagnan îl recomandă pentru fripturi, pește sau salate. Este un condiment versatil folosit foarte des în bucătăriile de inspirație internațională, dar și în mâncăruri de bază precum supe creme, mâncăruri prăjite pe bază de carne de pui, marinate sau pastrame.',
        name: 'Pui cu cartofi<br>copți în unt și<br>texturi de varză',
        image: 'large-coriandru-recipe.jpg'
    },
    {
        spice: '<strong>Ienibahar</strong> - Provine din Jamaica, iar aroma boabelor este puternică precum o combinație între nucșoară, ghimbir, scorțișoară și cuișoare. Datorită gustului cu accente piperate, intens și dulceag, Chef D’Artagnan alege să-l folosească pentru fripturi, tocănițe din carne sau cărnuri marinate. De asemenea, este foarte bun pentru prepararea sosurilor și parfumarea murăturilor.',
        name: 'Colțunași gătiți<br>pe grătar, umpluți<br>cu cașcavea afumată',
        image: 'large-ienibahar-recipe.jpg'
    }
];

$(window).load(function() {
    new TimelineMax({ease:Power2.easeInOut})
        .to('.section1-products',0.5,{opacity:1});
});

$('a.section3-frame').on('click', function(){
    if (!$(this).hasClass('active')) {
        var recipe = $(this).data('recipe');
        $('.modal-content').fadeOut({complete:function(){
            $('.modal-body').hide();
            $('#recipeModal').scrollTop(0);
            $('#modalRecipe'+recipe).show();
            $('.modal-content').fadeIn();
        }});
        $('.section3 a.active').removeClass('active');
        $(this).addClass('active');
        $('#recipe-spice').fadeOut(function(){
            $(this).html(largeRecipes[recipe].spice).fadeIn();
        });
        $('#recipe-name').fadeOut(function(){
            $(this).html(largeRecipes[recipe].name).fadeIn();
        });
        $('#recipe-image').fadeOut(function(){
            $(this).css({'background-image':'url(/themes/oamenisigusturi/img/equity/'+largeRecipes[recipe].image+')'}).fadeIn();
        });
    }
});

$('.section3-recipe').on('click', function(){
    $('#recipeModal').modal({backdrop: 'static'}).modal('show');
});

$('.modal-recipe-switch a').on('click', function(){
    $('.'+$(this).data('click')).trigger('click');
});

$('.section4-recipe').on('click',function(){
    if (!$(this).hasClass('active')) {
        $('.section4-recipe.active').removeClass('active');
        $('.section4-recipe-details.active').slideUp(function(){
           $(this).removeClass('active');
        });
        $(this).addClass('active').next().slideDown(function(){
            $(this).addClass('active');
            $('.section4-recipes-label').css({'transform':'translateY('+$('.section4-recipe.active').position().top+'px)'});
            $('html, body').animate({
				scrollTop: $('.section4-recipe.active').offset().top-$('nav.navbar').height()-10
			}, 300);
        });
    }
});
